


















import { computed, defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api';
import hash from 'object-hash';

import ValidationErrorMessage from '~/components/ValidationErrorMessage.vue';

interface Option {
  text: string;
  value: string;
}

export default defineComponent({
  name: 'AMXRadioButtonGroup',
  components: { ValidationErrorMessage },
  props: {
    options: {
      type: Array as PropType<Option[]>,
      required: true,
    },
    validationError: {
      type: String,
      default: null,
    },
    defaultValue: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const selected = ref(props.defaultValue);

    const uniqueId = computed(() => hash(props.options));
    const hasError = computed(() => !!props.validationError);

    watch(selected, (value) => {
      emit('on-change', value);
    });

    return {
      hasError,
      uniqueId,
      selected,
    };
  },
});
